import React, { useState } from 'react';
import LogoComponent from '../shared/LogoComponent';
import '../shared/styling.css';
import './RepairReplace.css';

// Example options and graph data
const REPAIR_REPLACE_OPTIONS = [
  { label: 'Repair', value: 'repair' },
  { label: 'Replace', value: 'replace' },
  { label: 'Wait', value: 'wait' },
  { label: 'Other', value: 'other' },
];

// Example graph data for each option
const GRAPH_DATA = {
  repair: [15, 30, 45, 60],
  replace: [25, 40, 55, 70],
  wait: [10, 20, 30, 40],
  other: [5, 15, 25, 35],
};

function RepairReplaceGraphScreen({ logoUrl, footerText }) {
  const [selectedOption, setSelectedOption] = useState(
    REPAIR_REPLACE_OPTIONS[0].value
  );

  // Simple bar graph rendering
  const graphBars = GRAPH_DATA[selectedOption].map((val, idx) => (
    <div
      key={idx}
      className="graph-bar"
      style={{
        height: `${val}px`,
        background: 'var(--secondary-color)',
        margin: '0 8px',
        width: '40px',
        borderRadius: '6px',
        display: 'inline-block',
        verticalAlign: 'bottom',
      }}
    >
      <span className="graph-bar-label">{val}</span>
    </div>
  ));

  return (
    <div className="diagnostic-container repair-replace-graph-screen">
      <LogoComponent src={logoUrl} alt="NearU Logo" />
      <div className="repair-replace-slider-group">
        {REPAIR_REPLACE_OPTIONS.map((option) => (
          <button
            key={option.value}
            className={`repair-replace-btn${selectedOption === option.value ? ' selected' : ''}`}
            onClick={() => setSelectedOption(option.value)}
            type="button"
          >
            {option.label}
          </button>
        ))}
      </div>
      <div className="graph-container">{graphBars}</div>
      <div className="repair-replace-footer-text">{footerText}</div>
    </div>
  );
}

export default RepairReplaceGraphScreen;
